module.exports = __webpack_public_path__ + "NewReport_Insights_Dark.0e324b5f59a51f50a2a366204de6645a.hashedasset.svg";